module.exports = __webpack_public_path__ + "static/assets/2b961bd17f7eada5215231d93aea9374.png";